export const signInSuccess = "signInSuccess";
export const showAlert = "showAlert";
export const resetAppState = "resetAppState";
export const fetchUserDataSuccess = "fetchUserDataSuccess";
export const fetchPostsSuccess = "fetchPostsSuccess";
export const fetchRegionsSuccess = "fetchRegionsSuccess";
export const fetchRegistrationsSuccess = "fetchRegistrationsSuccess";
export const takeActionOnRegistrationSuccess =
	"takeActionOnRegistrationSuccess";
export const sendOTPSuccess = "sendOTPSuccess";
export const verifyOTPSuccess = "verifyOTPSuccess";
export const imageUploadingSuccess = "imageUploadingSuccess";
export const fetchRetailersRankList = "fetchRetailersRankList";
export const fetchAllLangSuccess = "fetchAllLangSuccess";
export const setPageTitle = "setPageTitle";
export const setPageHeaderLogo = "setPageHeaderLogo";
export const fetchRetailerDataSuccess = "fetchRetailerDataSuccess";
export const resetRetailModule = "resetRetailModule";
export const resetCommonModule = "resetCommonModule";
export const resetSignUpModule = "resetSignUpModule";
export const resetUploadModule = "resetUploadModule";
export const resetUserModule = "resetUserModule";
export const resetJeet11Module = "resetJeet11Module";
export const getQRCodePdfSuccess = "getQRCodePdfSuccess";
// export const grabRetailerDataSuccess = "grabRetailerDataSuccess";
export const grabRetailerTransactionHistorySuccess =
	"grabRetailerTransactionHistorySuccess";

export const getReferralSuccess = "getReferralSuccess";
export const updatePaymentDetailsSuccess = "updatePaymentDetailsSuccess";
export const updatePaymentDetailsStatus = "updatePaymentDetailsStatus";
export const getWalletDetailsSuccess = "getWalletDetailsSuccess";
export const jeet11TransactionHistorySuccess =
	"jeet11TransactionHistorySuccess";
export const fetchJeet11PartnerWalletDetailsSuccess =
	"fetchJeet11PartnerWalletDetailsSuccess";
export const fetchJeet11UserSuccess = "fetchJeet11UserSuccess";

export const payJeet11UserSuccess = "payJeet11UserSuccess";

export const fetchJeet11DistributorRetailerListSuccess =
	"fetchJeet11DistributorRetailerListSuccess";
export const fetchJeet11RetailerTransactionHistorySuccess =
	"fetchJeet11RetailerTransactionHistorySuccess";

export const fetchFinanceAcknowledgementsSuccess =
	"fetchFinanceAcknowledgementsSuccess";
export const addFinanceAcknowledgementsSuccess =
	"addFinanceAcknowledgementsSuccess";

export const fetchAllRetailerDstrSuccess = "fetchAllRetailerDstrSuccess";

export const fetchRetailBannersSuccess = "fetchRetailBannersSuccess";
export const fetchCaptainTargetsSuccess = "fetchCaptainTargetsSuccess";
export const fetchUserStoriesSuccess = "fetchUserStoriesSuccess";
export const deleteUserStorySuccess = "deleteUserStorySuccess";

export const fetchJeet11PartnerRechargeHistorySuccess =
	"fetchJeet11PartnerRechargeHistorySuccess";

export const setDefaultUploadedDocuments = "setDefaultUploadedDocuments";
export const setJeet11UserProfile = "setJeet11UserProfile";

export const fetchUsersByRetailerIDSuccess = "fetchUsersByRetailerIDSuccess";

export const resetUsersByRetailerIDSuccess = "resetUsersByRetailerIDSuccess";

export const fetchRazorpayAccountDetailsSuccess =
	"fetchRazorpayAccountDetailsSuccess";

export const fetchMonthlyCommissionSuccess = "fetchMonthlyCommissionSuccess";

export const fetchProductsSuccess = "fetchProductsSuccess";

export const fetchTrasferCoinsUserDataSuccess =
	"fetchTrasferCoinsUserDataSuccess";

export const fetchDistributorCommissionSuccess =
	"fetchDistributorCommissionSuccess";

export const fetchDstrRetailersCommissionSuccess =
	"fetchDstrRetailersCommissionSuccess";

export const fetchUserMatchHistorySuccess = "fetchUserMatchHistorySuccess";

export const fetchUserRechargeHistorySuccess =
	"fetchUserRechargeHistorySuccess";

export const toggleAppMode = "toggleAppMode";

export const rummyTransactionHistorySuccess = "rummyTransactionHistorySuccess";

export const payRummyUserSuccess = "payRummyUserSuccess";

export const fetchRummyTransactionHistorySuccess =
	"fetchRummyTransactionHistorySuccess";

export const changeSalaryStructureSorting = "changeSalaryStructureSorting";

export const setAgencyData = "setAgencyData";
